// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const OutgoingTransfer = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="M9 16.219V1.78M3.094 7.688 9 1.78l5.906 5.907" />
  </svg>
);
const ForwardRef = forwardRef(OutgoingTransfer);
export default ForwardRef;
